'use strict';

define('features/inventory/inventory-detail',[
  'jquery',
  'Handlebars',
  'lib/util/zip',
  'lib/getParameterByName',
  'lib/services/inventory-service',
  'lib/services/offers-service',
  'lib/transforms/offers.tmpl.common',
  'lib/page-cache',
  'components/slicker',
  'lib/util/feature-expanders',
  'lib/util/tda.config',
  'lib/shim/gsap',
  'disclaimers',
  'lib/transforms/inventory',
  'lib/transforms/inventory.standardFeatures',
  'lib/transforms/inventory.detail',
  'lib/services/3dimages',
  'lib/filtersFromVehicleId',
  'features/recentVehicles',
  'lib/tda/kac',
  'dealerLiveChat',
  'tabControl',
  'features/ctas/index',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'inpageHeadline',
  'lib/scroller',

  // side effect includes (but not all of them should be)
  'isInViewport',
  'lib/helpers/disclaimer',
  'lib/helpers/ifCond',
  'jqueryui',
  'jquerytouch',
  'componentIsotope',
  'bat',
  'firstMoverParticipant',
  'lib/loader/series'
], function (
  $,
  Handlebars,
  zip,
  getParameterByName,
  inventoryService,
  offersFactory,
  xformOffersCommon,
  PageCache,
  Slicker,
  enableFeatureExpanders,
  tdaConfig,
  gsap,
  disclaimersService,
  inventoryXform,
  inventoryStandardFeaturesXform,
  inventoryDetailXform,
  imageService,
  filtersFromVehicleId,
  recentVehicles,
  kac,
  dealerLiveChat,
  tabControl,
  ctas,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext,
  inpageHeadline,
  scroller
) {
  var __availableOffers = {}; // global store for available offers related

  function __interiorExteriorImgs(self, res) {
    var modelCode = self._filters.model[0];
    var colorExt = self._filters.exteriorcolor[0];
    var colorInt = self._filters.interiorcolor[0];
    // GST-567 - missing images problem
    var exteriors = [];
    var interiors = [];

    try {
      exteriors = res.DataArea.model[modelCode].exteriorcolor[colorExt]['3dimage']['680_383_PNG'];
    } catch (ex) { }
    // BAT-4601, bad data on 2018 Tacoma interiocolor
    if (colorInt === 'Gray') {
      colorInt = 'FB14';
    }
    // GST-567, bad data on 2019 Tundra Limited intericolor
    if (colorInt === 'Black') {
      colorInt = 'LB20';
    }
    try {
      interiors = res.DataArea.model[modelCode].interiorcolor[colorInt]['3dimage']['680_383_PNG'];
    } catch (ex) { }

    var slideShowImages = [];

    for (var key in exteriors) {
      var curr = exteriors[key][0];
      slideShowImages.push(curr);
    }

    for (var key in interiors) {
      var curr = interiors[key][0];
      slideShowImages.push(curr);
    }
    return slideShowImages;
  }

  var InventoryDetail = function (el, config) {
    this._el = el;
    this.$el = $(el);
    this._config = config;
    this.Disclaimers = InventoryDetail.Disclaimers;
    this.initialize.apply(this, arguments);
  };

  // Do other files need this? Can it be shared? should it NOT be an obj?
  // Looks like something we'd like to avoid, even though so far, we don't need access to 'this' from within Disclaimer methods
  InventoryDetail.Disclaimers = {
    cachedDisclaimerMap: {},
    // Create a mapping between disclaimer number and disclaimer text
    createDisclaimersMap: function (disclaimersObj) {
      var self = this;
      disclaimersService.vehicleDisclaimers = [];
      var staticOffset = (document.getElementById('disclaimers-global-modal').outerHTML.match(/static-disclaimer/g) || []).length;
      var count = 0;
      var disclaimerMap = {}; //used to lookup replaces
      for (var key in disclaimersObj) {
        var obj = {
          symbol: count + staticOffset + 1,
          description: disclaimersObj[key].description
        };
        count++;
        disclaimerMap['[' + key + ']'] = obj.symbol;
        disclaimersService.vehicleDisclaimers.push(obj);
      }
      self.cachedDisclaimerMap = disclaimerMap;
    },
    // Replace disclaimer tags in text with readable numbers
    replaceDisclaimerTags: function (html) {
      var self = this;
      var cleanHtml = html;
      var results = html.match(/\[.*?\]/g);
      if (results) {
        $.each(results, function (i, val) {
          var replaceWith = '';
          if (self.cachedDisclaimerMap[val] !== undefined) {
            // Only do the following,
            // If this disclaimer falls inside of a <div class="card-inner">, within our html
            replaceWith = '<sup class="color-red footnote"><a href="#">' + self.cachedDisclaimerMap[val] + '</a></sup>';
          }
          // else console.log('Got an undefined disclaimer for: ' + val + " : " , __inventory.Disclaimers.cachedDisclaimerMap);
          cleanHtml = cleanHtml.replace(val, replaceWith);
        });
      }
      return cleanHtml;
    },
  };

  $.extend(InventoryDetail.prototype, {
    initialize: function (el, config) {
      console.log('InventoryDetail initialize: ', this);
    },

    load: function () {
      var self = this;
      self._filters = filtersFromVehicleId(getParameterByName('vehicleid'));
      self.series = getParameterByName('series');
      self.requestInventory();
      self.request3dImages();
      self.availableOffers();

      PageCache.awaitAll(['inventory.detail', 'inventory.detail.3dimages'])
        .then(function (res) {
          if (!res[0].body.response.numFound) {
            // BAT25-319:INVENTORY NOT FOUND, REDIRECT TO 404
            var newurl = '/' + tdaConfig.site.context_url + '/suggested-inventory/' + window.location.search;
            window.location.replace(newurl);
            return;
          }

          self.drawDetailView(res[0]); // top right area
          self.setupSlides(res[1]);
          // TODO: determine a better way to do this
          $(function () {
            // Have to wait until dom is fully ready otherwise disclaimer service breaks.
            self.Disclaimers.createDisclaimersMap(res[0].body.response.disclaimers);
          });
        })
        .catch(function (err) { console.log('err: ', err); }); // eslint-disable-line no-console
    },

    requestInventory: function () {
      var self = this;
      var cacheId = 'inventory.detail';
      var defaultFilters = {
        region: [tdaConfig.inventory.region_code], // shouldnt we actually just default to 600?
        series: [self.series],
        dealers: [],
        andfields: ['accessory', 'packages', 'exteriorcolor', 'grade']
      }
      var finalFilters = $.extend({}, defaultFilters, self._filters);
      var invRequest = {
        filter: finalFilters,
        fields: [],
        pagesize: 1,
        facetfields: [],
        group: 'true',
        groupmode: 'full',
        mode: 'content'
      };
      if (!PageCache.has(cacheId) && !PageCache.isPending(cacheId)) {
        PageCache.maybeSet(cacheId, inventoryService.inventory().getInventory(invRequest));
      }
    },

    request3dImages: function () {
      var self = this;
      var cacheId = 'inventory.detail.3dimages';
      if (!PageCache.has(cacheId) && !PageCache.isPending(cacheId)) {
        PageCache.maybeSet(cacheId, imageService.images().getImages({ series: self.series, year: self._filters.year[0] }));
      }
    },

    drawDetailView: function (res) {
      var self = this;
      // 1. xform into cards.
      var xformedCards = inventoryXform({ data: res });
      // 2. add standardFeatures to each card
      var cardsWithStandardFeatures = inventoryStandardFeaturesXform(xformedCards, res.body.response.standardfeatures);
      // 3. transform first (and only) xformedCards[] with standardFeatures into UIObject
      var uiObj = inventoryDetailXform(cardsWithStandardFeatures[0]);
      // 4. add features to parent uiObj
      uiObj.features = cardsWithStandardFeatures[0].features;
      self.uiObj = uiObj;
      self.saveSession();
      // 5. paint the screen with uiObj
      self.appendDetail(uiObj);
    },

    // Todo: move TPLs to text tpl, move selectors to self.
    // rename Tempate to Template
    // Move to seperate functions
    appendDetail: function (uiObj) {
      var self = this;
      // APPEND DETAIL.
      var cardTemplate = $('#inventoryDetailCardTempate').html();
      var cardHTML = Handlebars.hcompile(cardTemplate, uiObj);
      cardHTML = this.Disclaimers.replaceDisclaimerTags(cardHTML);
      $('#inventoryCardDetailOutput').html(cardHTML);

      this.changeTitleDetail();

      // The Info
      var infoTemplate = $('#inventoryDetailInfoTemplate').html();
      var infoHTML = Handlebars.hcompile(infoTemplate, uiObj);
      infoHTML = this.Disclaimers.replaceDisclaimerTags(infoHTML);
      $('#inventoryCardInfo').html(infoHTML);
      this.customCTAs(uiObj.card.year, uiObj.card.series, uiObj.card.modelcode); // BAT-3595 Vehicle Compare Links Functionality for Compare CTAs (local vs global vehicle association)
      // The Features
      var featuresTemplate = $('#inventoryDetailFeaturesTemplate').html();
      var featuresHTML = Handlebars.hcompile(featuresTemplate, uiObj);
      featuresHTML = this.Disclaimers.replaceDisclaimerTags(featuresHTML);
      $('#inventoryDetailFeaturesOutput').html(featuresHTML);
      enableFeatureExpanders();
      // TODO: determine a better way to do this
      $(function () {
        // Have to wait until dom is fully ready otherwise disclaimer service breaks.
        disclaimersService.msrpMpgDigits('#inventoryCardDetailOutput');
        disclaimersService.appendDisclaimers(); // Needed for potentially inline disclaimers
        self.disclaimerClicks();
      });
    },

    customCTAs: function (year, series, modelCode) {
      ctas.dealerSite(this.$el);
      ctas.compare(year, series, this.$el);
      ctas.dealBuilder(year, series, this.$el);

      // add series, year, and trim to the Estimate Payment CTA (if it exists)
      // Todo: turn this into a CTA that lives in features/ctas
      var $estimatePaymentCta = $("a[data-destination='payment-calculator']");
      if ($estimatePaymentCta && $estimatePaymentCta.length) {
        var newUrl = $estimatePaymentCta.attr('href') + '?series=' + series + '&year=' + year + '&trimCode=' + modelCode;
        $estimatePaymentCta.attr('href', newUrl);
      }

      var $clickToChatCta = $("a[data-destination='live-chat']");
      var providerId = tdaConfig.chat.provider_id;
      if (($clickToChatCta.length > 0) && (providerId !== '')) {
        if (tdaConfig.tda.code === 'KAC10') {
          $clickToChatCta.addClass('etsChatButton');
          $clickToChatCta.attr('data-destination', 'live-chat-kac');
          kac.dealerChat(); // BAT-2915 KAC only Chat w/Dealer CTAs
        } else {
          dealerLiveChat.init(providerId);
        }
      }
    },

    setupSlides: function (res) {
      var self = this;
      self.uiObj.summary.images = __interiorExteriorImgs(self, res);
      var carouselTemplate = $('#inventoryDetailCarouselTemplate').html();
      var carouselHTML = Handlebars.hcompile(carouselTemplate, self.uiObj);
      $('.inventory-detail-carousel').html(carouselHTML);
      self.doSlideshow();
      self.doDataLayer();
    },

    doSlideshow: function () {
      var self = this;
      return new Slicker({
        $slider: $('.inventory-detail-carousel'),
        slickOptions: {
          mobileFirst: true,
          dots: true,
          arrows: true,
          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 1,
          infinite: true,
          initialSlide: 0,
          slide: '.id-carousel-item',
          paddingBottom: '25px',
          appendArrows: $('.inventory-detail-carousel'), // custom location for our custom prev/next arrows
          prevArrow: '<div class="carousel-prev datalayer-link" data-linktext="model_selector_previous"><button class="bx-prev unstyled" aria-label="Show Previous Slide"><i class="icon icon-arrow-thin-left"></i></button></div>',
          nextArrow: '<div class="carousel-next datalayer-link" data-linktext="model_selector_next"><button class="bx-next unstyled" aria-label="Show Next Slide"><i class="icon icon-arrow-thin-right"></i></button></div>',
          initFunction: function () {
            var $bxPrev = $('.bx-prev');
            var $bxNext = $('.bx-next');
            // PREVIOUS ARROW KEY DOWN BAT-4016
            // TODO: This belongs in slicker
            $bxPrev.keydown(function (event) {
              if (event.keyCode !== 13 && event.keyCode !== 9) {
                event.preventDefault();
                event.stopPropagation();
                return;
              }
              if (event.keyCode === 13) {
                $bxPrev.find('i').trigger('click');
              }
            });
            // NEXT ARROW KEY DOWN BAT-4016
            $bxNext.keydown(function (event) {
              if (event.keyCode !== 13 && event.keyCode !== 9) {
                event.preventDefault();
                event.stopPropagation();
                return;
              }
              if (event.keyCode === 13) {
                $bxNext.find('i').trigger('click');
              }
            });
          },
          beforeFunction: function (e, slick, currentSlide, nextSlide) {
            // TODO: move this out to a shared function that lives in lib/animations (see vehicle-info.js)
            var $imgs = $('.id-carousel-item img').not('.id-carousel-item.slick-active img');
            gsap.TweenMax.to($imgs, 0, { scale: 1.3 });
            gsap.TweenMax.to($imgs, 0.5, { scale: 1 });
            gsap.TweenMax.to($imgs, 0.5, { scale: 1.01, delay: 0.5 });
            anAddContext(self.$el, blocks.listItemBlock(nextSlide));
          }
        }
      });
    },

    doDataLayer: function () {
      anAddContext(this.$el, blocks.seriesBlock(this.uiObj.card), blocks.listItemBlock(0));
      anPageLoad(this.$el, blocks.keyMetrics('km-inventory-detail'));
      anClicks(this.$el);
    },

    // TODO: move this to a func of inpage-headline.js
    changeTitleDetail: function () {
      inpageHeadline.init();
      var self = this;
      var title = self.uiObj.card.year + ' ' + self.uiObj.card.name;
      title = title.replace(/\s(\w+\s)\1/, ' $1');
      $('#inpage-headline').html(title);
      $('.js-inpage-headline-back a').parent('p').show();
      $('.js-inpage-headline-back a').on('click', function (e) {
        e.preventDefault();
        window.history.back();
      });
      $('#inventory-detail').data('series', self.uiObj.card.series);
    },

    disclaimerClicks: function () {
      this.$el.on('click', '.footnote a', function (e) {
        e.preventDefault();
        disclaimersService.handleDisclaimers('vehicle', $(e.target).text());
      });
    },
    // Save this vehicle to recent sessionStorage
    saveSession: function () {
      var card = this.uiObj.card;
      recentVehicles.saveVehicle({
        year: card.year,
        series: card.series,
        trim: card.trim,
        trimCode: card.modelcode.substring(card.modelcode.indexOf('_') + 1, card.modelcode.length)
      });
    },

    // TODO: move offers handling out of inventory-detail entirely
    availableOffers: function () {
      var self = this;
      if (self._config.availableOffersDisplay) {
        // GET ADDITIONAL OFFERS, SHOW THE SECTION.
        // console.log('::: regionCOde:', regionCode, '\ntda:', tda, '\nzc:', zc);
        var options = {
          tdaCode: tdaConfig.tda_code,
          zipCode: zip.getCookiedDefaultFallback(),
          series: self.series, // 'corolla',
          pageSize: 8 // 25 test more.
        };

        offersFactory(tdaConfig.offers.r2_api_key).offers().all(options)
          .then(function (res) {
            return xformOffersCommon(res.offerBundle.offers);
          })
          .then(function (transFormedOffers) {
            self.drawOffers(transFormedOffers);
          });
      }
    },

    drawOffers: function (transFormedOffers) {
      var available_offers_slider = false;
      for (var k = 0; k < transFormedOffers.length; k += 1) {
        transFormedOffers[k].localId = k; // localId used for matching to spawn mobile modal
      }
      __availableOffers.availableOffersList = transFormedOffers;
      $('.available-offers-section').css({ display: 'block' });
      try {
        Handlebars.registerPartial('offerDetailsPartial', $('#offerDetailsPartial').html());
        Handlebars.registerPartial('modalDetailsPartial', $('#modalDetailsPartial').html());

        var aoTemplate = $('#availableOffersTemplate').html(); // id changed from 'additional-inventory-cards'
        // misc lease cash. TODO: msrp and special.
        var listHTML = Handlebars.hcompile(aoTemplate,
          {
            offers: transFormedOffers,
            renderOffer: function () {
              var tempTemp;
              var tempHtml;
              switch (this.offerType) {
                case 'apr':
                  tempTemp = $('#aprTemplate').html();
                  tempHtml = Handlebars.hcompile(tempTemp, { offer: this });
                  return new Handlebars.SafeString(tempHtml);
                case 'lease':
                  tempTemp = $('#leaseTemplate').html();
                  tempHtml = Handlebars.hcompile(tempTemp, { offer: this });
                  return new Handlebars.SafeString(tempHtml);
                case 'cash':
                  tempTemp = $('#cashTemplate').html();
                  tempHtml = Handlebars.hcompile(tempTemp, { offer: this });
                  return new Handlebars.SafeString(tempHtml);
                case 'msrp':
                  tempTemp = $('#msrpTemplate').html();
                  tempHtml = Handlebars.hcompile(tempTemp, { offer: this });
                  return new Handlebars.SafeString(tempHtml);
                case 'misc':
                  tempTemp = $('#miscTemplate').html();
                  tempHtml = Handlebars.hcompile(tempTemp, { offer: this });
                  return new Handlebars.SafeString(tempHtml);

                default:
                  // no default.
                  break;
              }
            },
            renderSlideOffer: function () {
              var slideTemp;
              var tempHtml;
              switch (this.offerType) {
                case 'apr':
                  slideTemp = $('#aprSlideTemplate').html();
                  tempHtml = Handlebars.hcompile(slideTemp, { offer: this });
                  return new Handlebars.SafeString(tempHtml);
                case 'lease':
                  slideTemp = $('#leaseSlideTemplate').html();
                  tempHtml = Handlebars.hcompile(slideTemp, { offer: this });
                  return new Handlebars.SafeString(tempHtml);
                case 'cash':
                  slideTemp = $('#cashSlideTemplate').html();
                  tempHtml = Handlebars.hcompile(slideTemp, { offer: this });
                  return new Handlebars.SafeString(tempHtml);
                case 'msrp':
                  slideTemp = $('#msrpSlideTemplate').html();
                  tempHtml = Handlebars.hcompile(slideTemp, { offer: this });
                  return new Handlebars.SafeString(tempHtml);
                case 'misc':
                  slideTemp = $('#miscSlideTemplate').html();
                  tempHtml = Handlebars.hcompile(slideTemp, { offer: this });
                  return new Handlebars.SafeString(tempHtml);
                default:
                  // no default.
                  break;
              }
            }
          });

        $('#availableOffersOutput').html(listHTML);
        // TODO: determine a better way to do this
        $(function () {
          // Have to wait until dom is fully ready otherwise disclaimer service breaks.
          disclaimersService.msrpMpgDigits('#availableOffersOutput');
        });

        // DRAW SLIDE SHOW.
        var drawAdditionalOfferSlideshow = function () {
          if (available_offers_slider !== false) return;

          try {
            // BAT-2980 NEW SLIDER.
            var initFunction = function () {
              // LOADED.
              // SLICK initFunction
              // HIDE PLACEHOLDES ON IMG LOAD:
              $('.additional-offers-carousel .jelly').each(function (index, item) {
                var img = $(item).find('img');
                img.on('load', function () {
                  $(item).addClass('loaded');
                });
              });

              var slideClick = function (event) {
                var currentTarget = $(event.currentTarget);
                var localId = Number(currentTarget.attr('data-localId'));
                var store = __availableOffers.availableOffersList;// window.offerDetail.additionalInventoryItems;
                var selectedItem = {};
                for (var i = 0; i < store.length; i++) {
                  if (localId === store[i].localId) {
                    selectedItem = store[i];
                    break;
                  }
                }
                if (!$.isEmptyObject(selectedItem)) {
                  try {
                    switch (selectedItem.offerType) {
                      case 'apr':
                        $('#modalOutput').html(__availableOffers.modHTML_apr({ data: selectedItem, allCards: store }));
                        break;

                      case 'lease':
                        $('#modalOutput').html(__availableOffers.modHTML_lease({ data: selectedItem, allCards: store }));
                        break;

                      case 'cash':
                        $('#modalOutput').html(__availableOffers.modHTML_cash({ data: selectedItem, allCards: store }));
                        break;

                      case 'msrp':
                        $('#modalOutput').html(__availableOffers.modHTML_msrp({ data: selectedItem, allCards: store }));
                        break;

                      case 'misc':
                        $('#modalOutput').html(__availableOffers.modHTML_misc({ data: selectedItem, allCards: store }));
                        break;

                      default:
                        // no default
                        break;
                    }

                    // CLONE THE TEMP CTAS (driven from InventoryDetail/ctas ) AND DISPLAY THEM IN MODAL.
                    var clone = $('#temp_ctas').clone('.ctas');
                    $('#additionalInventoryModalCTAs').append(clone);
                    $('#additionalInventoryModalCTAs #temp_ctas').show(); // show the cloned cta's within the cntext of thier parental modal.
                    $('#additional-offer-modal').modal().modal('show');

                    // FEATURE EXPANDERS.
                    $('.inventory-detail-offer-modal .feature-expander').each(function (index, item) {
                      $(item).on('click', function () {
                        $(item).find('.icon-arrow-up').toggleClass('active');
                        $(item).find('.icon-arrow-down').toggleClass('active');
                        var expansion = $(this).parents().find('.feature-content').eq(index);
                        expansion.toggleClass('expanded');
                      });
                    });
                  } catch (error) {
                    console.log(' ::: MODAL ERROR ', error);
                  }

                  // HANDLE MODAL DISCLAIMER FOOTNOTE CLICKS.
                  // processDisclaimersBySelector('.od-modal-details .feature-content li', true);
                } else {
                  // hmm, no data, no modal.
                }
              }

              // ASSIGN CLICK HANDLING TO THE SILDES TO YIELD MODAL.
              $('.slick-slider').on('click', '.slick-slide', slideClick);
            };

            /*
              this slide show for mobile only.
            */
            available_offers_slider = new Slicker({
              // $component: $item.find('.header-all-vehicles-wrap'),
              $slider: $('.additional-offers-carousel'),
              slickOptions: {
                mobileFirst: true,
                dots: true,
                arrows: true,
                centerMode: true,
                centerPadding: '50px',
                paddingBottom: '60px',
                slidesToShow: 1,
                infinite: false,
                initialSlide: 3,
                slide: '.inventory-offer-card-mob',
                initFunction: initFunction
              }
            });
            __availableOffers.additionalInventoryDisplayCount = 8; // window.offerDetail.additionalInventoryDisplayCount = 8;
            // viewMoreAdditional();
          } catch (error) {
            console.log('  ::: slide show ERROR ::: ', error);
          }
        }; // END SLIDESHOW
      } catch (error) {
        console.log('ERROR', error); // eslint-disable-line no-console
      }
      // INITIAL DIPLAY COUNT:
      __availableOffers.additionalOfferDisplayCount = 4; // 25 to test more types.
      // VIEW MORE ADDITIONAL:
      var viewMoreAdditional = function () {
        $('.inventory-offer-card').each(function (index, item) {
          // console.log(':: index', index, 'additionalOfferDisplayCount', __availableOffers.additionalOfferDisplayCount)
          if (index < __availableOffers.additionalOfferDisplayCount  && !$(item).hasClass('viewable')) {
            $(item).addClass('viewable');
            $('.inventory-offer-card').focusin(function (item) {
              // BAT-4431: ADA WHEN TABBING INTO THE CARD, WE NEED TO OPEN IT.
              if (tabControl.usingKeys &&  !$(this).hasClass('expanded-height')) {
                $(this).trigger('click');
              }
            });
          }
        });

        if (__availableOffers.availableOffersList.length < __availableOffers.additionalOfferDisplayCount) {
          $('.view-more-additional').remove();
        }
      };
      // FIRST FOUR OFFERS:
      viewMoreAdditional();
      drawAdditionalOfferSlideshow();
      // PRE-COMPILE MODAL TEMPLATE, POPULATED ABOVE.
      var modalAPRTemplate = $('#availableOfferModalTemplateAPR').html();
      __availableOffers.modHTML_apr = Handlebars.compile(modalAPRTemplate);
      var modalLeaseTemplate = $('#availableOfferModalTemplateLease').html();
      __availableOffers.modHTML_lease = Handlebars.compile(modalLeaseTemplate);
      var modalCashTemplate = $('#availableOfferModalTemplateCash').html();
      __availableOffers.modHTML_cash = Handlebars.compile(modalCashTemplate);
      var modalMSRPTemplate = $('#availableOfferModalTemplateMSRP').html();
      __availableOffers.modHTML_msrp = Handlebars.compile(modalMSRPTemplate);
      var modalMiscTemplate = $('#availableOfferModalTemplateMisc').html();
      __availableOffers.modHTML_misc = Handlebars.compile(modalMiscTemplate);

      var toggleCard = function (offerCard) {
        // BAT-2986.  modeled after toggleCard ( BAT-2980) in offer-detail.js
        // console.log('toggle card', offerCard);
        var expanding;
        var uparrow = $(offerCard).find('.card-expander .icon-arrow-up');
        var downarrow = $(offerCard).find('.card-expander .icon-arrow-down');
        uparrow.toggleClass('active');
        downarrow.toggleClass('active');
        var cardExpander = $(offerCard).find('.card-expander');

        // cardExpander.removeClass('datalayer-link'); // REMOVE THE datalayer-link FROM THE ELMENET SO IT'S CLICK DOES NOT GET PASSED.

        if ($(offerCard).hasClass('expanded-height')) {
          expanding = false;
          offerCard.removeClass('expanded-height');
        } else {
          expanding = true;
          offerCard.addClass('expanded-height');
        }

        var details = offerCard.find('.details');
        var ctasAnimating = offerCard.find('.ctas');
        var disclaimers = offerCard.find('.disclaimers');
        var offerBadges = offerCard.find('.offer-badges');

        if (expanding) {
          // EXPAND:
          var dlString = cardExpander.attr('data-layer');
          var datalayerData = JSON.parse(dlString);
          // BAT-3345 ADD ANALYTIC EVENT.
          datalayerData.fireTagShortPhrase = 'km-offers-detail'; //'aa-link';
          // datalayerData.metrics = 'km-offers-detail';
          $.extend(window.dataLayerBAT.data, datalayerData);
          window.dataLayerBAT.utils.triggerEvent(document, 'DL.CLICK');
          $(offerCard).addClass('expanded-height');
          // ewrow.removeClass('animate-out').addClass('animate');
          details.removeClass('animate-out').addClass('animate');
          ctasAnimating.removeClass('animate-out').addClass('animate');
          offerBadges.removeClass('animate-out').addClass('animate');
          disclaimers.removeClass('animate-out').addClass('animate');
        } else {
          // COLLAPSE:
          details.removeClass('animate').addClass('animate-out');
          ctasAnimating.removeClass('animate').addClass('animate-out');
          offerBadges.removeClass('animate').addClass('animate-out');
          disclaimers.removeClass('animate').addClass('animate-out');
          offerCard.removeClass('expanded-height');
        }
      };

      // CAPTRUE CARD CLICKS. ONLY PASS EVENTS THAT ARE LESS THAN THE HEIGHT OF THE CLOSED VERSION OF THE CARD.
      $('.inventory-offer-card').on('click', function (event) {
        var oCard = $(this);
        var yPos = event.pageY - oCard.offset().top;
        if (yPos > 149) {
          // DO NOT PASS THRU.
          return;
        }
        toggleCard(oCard);
      });

      // VIEW MORE BUTTON.
      $('.view-more-additional').on('click', function () {
        switch (__availableOffers.additionalOfferDisplayCount) {
          case 4:
            __availableOffers.additionalOfferDisplayCount = 6;
            break;

          case 6:
            __availableOffers.additionalOfferDisplayCount = 8;
            $(this).addClass('remove');
            break;
          default:
            break;
        }
        viewMoreAdditional();
      });

      if (__availableOffers.availableOffersList.length > 4) {
        $('.view-more-additional').addClass('viewable');
      }
      __availableOffers.availableListlistDrawn = true;

      // TODO: move outta here, but we have all the data here. Decisions decisions.
      var $scope = $('#section_available_offers');
      var offerYear = transFormedOffers[0].model.year;
      var offerSeriesCode = transFormedOffers[0].model.code;
      // note that there's no call to customCTAs after offers drawn. That is likely an error
      ctas.dealerSite($scope);
      ctas.compare(offerYear, offerSeriesCode, $scope);
      anAddContext(
        $scope,
        blocks.sectionBlock('Available Offers'),
        blocks.seriesBlock({
          series_code: offerSeriesCode,
          year: offerYear
        })
      );

      // add offer context to each offer

      this.analyticsOffers();
    },

    analyticsOffers: function () {
      var $scope = $('#availableOffersOutput');
      anClicks($scope);
      scroller.add($scope, {
        after: function viewAfter() {
          anPageLoad($scope);
        }
      });
    }
  });

  return InventoryDetail;
});

